var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.13648 11.0156H1.75781C0.788555 11.0156 0 10.2271 0 9.25781V2.22656C0 1.2573 0.788555 0.46875 1.75781 0.46875H4.55367C5.02318 0.46875 5.46463 0.651592 5.79662 0.983613L6.45363 1.64062H9.72656C10.6958 1.64062 11.4844 2.42918 11.4844 3.39844V4.6292C11.4844 4.95281 11.2221 5.21514 10.8984 5.21514C10.5748 5.21514 10.3125 4.95281 10.3125 4.6292V3.39844C10.3125 3.07535 10.0496 2.8125 9.72656 2.8125H6.21094C6.05555 2.8125 5.90648 2.75077 5.79662 2.64088L4.96799 1.81225C4.85731 1.70156 4.71018 1.64062 4.55367 1.64062H1.75781C1.43473 1.64062 1.17188 1.90348 1.17188 2.22656V9.25781C1.17188 9.5809 1.43473 9.84375 1.75781 9.84375H4.13648C4.4601 9.84375 4.72242 10.1061 4.72242 10.4297C4.72242 10.7533 4.4601 11.0156 4.13648 11.0156Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21094 14.5312C5.88732 14.5312 5.625 14.2689 5.625 13.9453V12.1875C5.625 9.9259 7.46496 8.08594 9.72656 8.08594H10.3125V7.5C10.3125 6.85383 10.8382 6.32812 11.4844 6.32812C11.7973 6.32812 12.0916 6.44997 12.3129 6.67125L14.6568 9.01509C14.8781 9.23651 15 9.53077 15 9.84375C15 10.1567 14.8781 10.451 14.6569 10.6723L12.3131 13.0161C12.0916 13.2375 11.7973 13.3594 11.4844 13.3594C10.8382 13.3594 10.3125 12.8337 10.3125 12.1875V11.6016H8.55469C7.58543 11.6016 6.79688 12.3901 6.79688 13.3594V13.9453C6.79688 14.2689 6.53455 14.5312 6.21094 14.5312ZM8.55469 10.4297H10.8984C11.2221 10.4297 11.4844 10.692 11.4844 11.0156V12.1875L13.8282 9.84375L11.4844 7.49997L11.4844 8.67188C11.4844 8.99549 11.2221 9.25781 10.8984 9.25781H9.72656C8.61812 9.25781 7.65152 9.8765 7.15395 10.7868C7.57028 10.5592 8.04771 10.4297 8.55469 10.4297Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.c6dc5cc691d3fe0341fcdd4d824e283d.svg";
export { ForwardRef as ReactComponent };